import React, { useState } from 'react'
import { Col, DatePicker, Form, Input, Row, TimePicker } from 'antd'
import { useUpdateLeagueGame } from 'api/league/leagueGames/leagueGames'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { convertTimeToUtcMinutes } from 'helper/utility'
import moment from 'moment'
import { leagueGamesStore } from 'state/league/leageGames'
import { leagueEventStore } from 'state/league/leagueEvent'
import { myStore } from 'state/store'
import { Address } from 'types/globalTypes'
import Location from 'pages/Events/Views/CreateLeague/screens/Step1/InputComps/Location'
import { OrganizationVenues } from 'types/organization'
import VenueModal from 'pages/Events/Views/CreateEvent/Screens/GeneralDetails/GeneralDetailModal/VenueModal'

const EditTimeModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { leagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
  }))
  const { editFieldModal, setEditFieldModal, selectedGame, setSelectedGame } =
    leagueGamesStore(store => ({
      editFieldModal: store.editFieldModal,
      setEditFieldModal: store.setEditFieldModal,
      selectedGame: store.selectedGame,
      setSelectedGame: store.setSelectedGame,
    }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)

  const [mapData, setMapModalData] = useState<Address | undefined>(
    selectedGame ? selectedGame.location : undefined,
  )
  const [venueModalVisible, setVenueModalVisible] = useState<boolean>(false)
  const [venueDataItem, setVenueDataItem] = useState<OrganizationVenues | null>(
    selectedGame ? selectedGame.venue : null,
  )

  const { mutate: updateLeagueGame } = useUpdateLeagueGame()

  const formSchema = {
    courtFieldNumber: selectedGame ? selectedGame.courtFieldNumber : null,
  }

  const handleClose = () => {
    setSelectedGame(null)
    setEditFieldModal(false)
  }

  const handleFinish = values => {
    const payload = {
      locationId: mapData._id,
      venueId: venueDataItem._id,
      courtFieldNumber: values.courtFieldNumber,
    }
    setModalBtnLoader(true)

    updateLeagueGame(
      { payload: payload as any, gameId: selectedGame._id },
      {
        onSuccess: () => {
          setModalBtnLoader(false)
          handleClose()
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      },
    )
  }

  return (
    <>
      <CustomModal
        openModal={editFieldModal}
        isCloseModalCustom
        closeModal={handleClose}
        title="Edit Field"
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save time"
            closeModal={handleClose}
            onSubmit={handleSubmit}
          />
        }
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={formSchema}
          onFinish={handleFinish}
        >
          {leagueData.organizationId && (
            <Row>
              <Col span={24}>
                <Location
                  selectedOrganization={{ id: leagueData.organizationId }}
                  mapData={mapData}
                  setMapModalData={setMapModalData}
                  form={form}
                />
              </Col>
            </Row>
          )}

          {mapData && (
            <Row className="mt-20px">
              <Col>
                <label className="input-label required-input">Venue</label>
              </Col>
              <Col>
                <div
                  className="w-full border-1px radius-10 flex align-center px-12px pointer h-50px"
                  onClick={() => setVenueModalVisible(true)}
                >
                  {venueDataItem ? (
                    <div className=" w-full flex justify-between align-center">
                      <p className="text-gray">{`${venueDataItem.name}`}</p>
                    </div>
                  ) : (
                    <p className="text-gray">Select Venue</p>
                  )}
                </div>
              </Col>
            </Row>
          )}

          <Row gutter={20} className="mt-20px">
            <Col>
              <label className="input-label required-input">
                Court / field number
              </label>
              <Form.Item
                className="pointer selector-input"
                name="courtFieldNumber"
              >
                <Input
                  type="number"
                  min={0}
                  placeholder="0"
                  className="br-12"
                  onWheel={e => e.currentTarget.blur()}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </CustomModal>

      {venueModalVisible && (
        <VenueModal
          mapData={leagueData.location}
          setVenueModalVisible={setVenueModalVisible}
          //   setFieldsValue={setFieldsValue}
          organizationId={leagueData?.organizationId}
          setVenueDataItem={setVenueDataItem}
        />
      )}
    </>
  )
}

export default EditTimeModal
